import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};
export const isMessagingSupported = () => {
  const isSecure = window.isSecureContext; // true only for https or localhost
  const hostname = window.location.hostname;

  // If using IP address → disable
  const isIP = /^[0-9.]+$/.test(hostname);

  // Conditions where messaging is supported:
  // - HTTPS
  // - localhost (allowed by service worker spec)
  if (!isSecure || isIP) return false;

  // Check SW support
  if (!('serviceWorker' in navigator)) return false;

  return true;
};

const firebaseApp = initializeApp(firebaseConfig);
let messaging = null;

if (isMessagingSupported()) {
  messaging = getMessaging(firebaseApp);
} else {
  console.warn('⚠ Firebase Messaging disabled: HTTP or IP environment.');
}

// Function to request permission for notifications
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification?.requestPermission();
    if (permission === 'granted') {
      return true;
    } else {
      return false;
    }
  } catch {
    return false;
  }
};

// Function to get the Firebase token
export const getOrRegisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    return window.navigator.serviceWorker.getRegistration('/').then((serviceWorker) => {
      if (serviceWorker) return serviceWorker;
      return window.navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/',
        type: 'module',
      });
    });
  }
  throw new Error('The browser doesn`t support service worker.');
};

// Function to get the Firebase token after ensuring permission is granted
export const getFirebaseToken = async () => {
  const permissionGranted = await requestNotificationPermission();
  if (!permissionGranted) {
    throw new Error('Notification permission not granted');
  }

  return getOrRegisterServiceWorker().then((serviceWorkerRegistration) =>
    getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration,
    }),
  );
};

// Function to handle foreground messages
export const onForegroundMessage = () =>
  new Promise((resolve) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => resolve(payload));
  });
